import MergeType from '@material-ui/icons/MergeType'
import CategoryAdd from './CategoryAdd'
import CategoryEdit from './CategoryEdit'
import CategoryList from './CategoryList'

const categories = (permissions) => ({
  create: permissions.includes('create:categories') ? CategoryAdd : undefined,
  edit: permissions.includes('update:categories') ? CategoryEdit : undefined,
  icon: MergeType,
  list: permissions.includes('read:categories') ? CategoryList : undefined,
  name: 'categories',
})

export default categories
